import { useTheme } from "@emotion/react";
import { Box, useMediaQuery } from "@mui/material";
import { createContext, useCallback, useContext, useReducer } from "react";

const pageReducer = (state, action) => {
    if (action.type === "SET_LOADING") {
        return {
            ...state,
            [`${action.target}Loading`]: action.loading,
        };
    }

    if (action.type === "SET_LIST") {
        return {
            ...state,
            list: action.data,
        };
    }

    if (action.type === "SET_DATA") {
        return {
            ...state,
            data: action.data,
        };
    }

    if (action.type === "SET_OVERVIEW") {
        return {
            ...state,
            overview: action.data,
        };
    }

    if (action.type === "SET_SIDE_DATA") {
        return {
            ...state,
            sideData: action.data,
        };
    }

    if (action.type === "SET_IS_FULL") {
        return {
            ...state,
            isFull: action.isFull,
        };
    }

    return state;
};

const initState = (options) => {
    return {};
};

export const usePageState = (options) => {
    const theme = useTheme();
    const isFull = !!useMediaQuery(theme.breakpoints.up(options?.fullBreakpoint || "lg"));

    const [state, dispatch] = useReducer(pageReducer, {}, initState);

    const setListLoading = useCallback(
        (loading) => {
            dispatch({ type: "SET_LOADING", target: "list", loading });
        },
        [dispatch]
    );

    const setList = useCallback(
        (data) => {
            dispatch({ type: "SET_LIST", data });
        },
        [dispatch]
    );

    const setDataLoading = useCallback(
        (loading) => {
            dispatch({ type: "SET_LOADING", target: "data", loading });
        },
        [dispatch]
    );

    const setData = useCallback(
        (data) => {
            dispatch({ type: "SET_DATA", data });
        },
        [dispatch]
    );

    const setOverviewLoading = useCallback(
        (loading) => {
            dispatch({ type: "SET_LOADING", target: "overview", loading });
        },
        [dispatch]
    );

    const setOverview = useCallback(
        (data) => {
            dispatch({ type: "SET_OVERVIEW", data });
        },
        [dispatch]
    );

    const setSideData = useCallback(
        (data) => {
            dispatch({ type: "SET_SIDE_DATA", data });
        },
        [dispatch]
    );

    return {
        state,
        setListLoading,
        setList,
        setDataLoading,
        setData,
        setSideData,
        setOverview,
        setOverviewLoading,
        isFull,
    };
};

export const PageContext = createContext({
    isFull: true,
    setFull: () => {},
});

export const MainPage = ({ children }) => {
    return (
        <>
            <Box
                sx={(theme) => ({
                    flex: "1 1 auto",
                    display: "flex",
                    flexDirection: "row",
                    minHeight: 0,
                })}>
                {children}
            </Box>
        </>
    );
};

export const ListView = ({ children }) => {
    const { isFull, detailId } = useContext(PageContext);

    return (
        <Box
            sx={() => ({
                flex: "0 0 auto",
                flexBasis: isFull ? 460 : "100%",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                maxWidth: "100%",
                overflow: "hidden",
            })}>
            {children}
        </Box>
    );
};

export const MainView = ({ children }) => {
    return (
        <Box
            sx={() => ({
                flex: "1 1 auto",
                minHeight: 0,
                overflow: "hidden",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                padding: 0,
            })}>
            {children}
        </Box>
    );
};
